<div class="row">
  <div class="col-12">
    <div class="card">

      <!-- Header -->
      <div class="card-header filter">
        <span class="filterspan">{{ header }}</span>
      </div>

      <!-- Body -->
      <div class="card-body">

        <!-- MAIN GRID -->
        <div class="row g-3 align-items-center">

          <!-- ================= LEFT SIDE FILTERS ================= -->
          <div class="col-12 col-xl-9">
            <div class="row g-3">

              <!-- LOCKED SITE (single-site context) -->
              <div class="col-12 col-sm-6 col-md-4 col-lg-3"
                   *ngIf="siteid !== 'ALL'">
                <button
                  class="btn btn-light text-dark w-100 h-100 d-flex align-items-center justify-content-between"
                  type="button"
                  disabled>
                  <span>{{ lockedSiteName }}</span>
                </button>
              </div>

              <!-- ── SITE MULTI-SELECT ── -->
              <div class="col-12 col-sm-6 col-md-4 col-lg-3"
                   *ngIf="showSiteDropdown && !lockedSiteName">
                <div class="w-100" ngbDropdown [autoClose]="'outside'" style="height:40px">
                  <button
                    class="btn text-dark dropdown-toggle d-flex justify-content-between align-items-center w-100"
                    type="button" ngbDropdownToggle>
                    <span>{{ getSelectedSiteNames() }}</span>
                    <span *ngIf="selectedItemsCount > 0"
                          class="badge bg-primary counter ms-2">{{ selectedItemsCount }}</span>
                  </button>

                  <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width:250px; max-height:300px; overflow-y:auto;">

                    <!-- search -->
                    <li class="px-1 py-1 sticky-top bg-white search-container">
                      <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                           style="position:absolute;right:7px;top:7px;">
                      <input type="text"
                             class="form-control form-control-sm searchbar"
                             placeholder="Search Sites..."
                             [(ngModel)]="searchTerm"
                             (click)="handleItemClick($event)"
                             aria-label="Search sites">
                    </li>
                    <li><hr class="dropdown-divider mt-1 mb-0"></li>

                    <!-- shimmer -->
                    <ng-container *ngIf="siteloading; else siteItemsTpl">
                      <li class="list" *ngFor="let _ of shimmerArray">
                        <div class="dropdown-item d-flex align-items-center px-2 py-1 shimmer-item">
                          <div class="shimmer-text me-2" style="width:16px;height:16px;border-radius:3px;"></div>
                          <div class="shimmer-text flex-grow-1" style="height:14px;"></div>
                        </div>
                      </li>
                    </ng-container>

                    <!-- real items -->
                    <ng-template #siteItemsTpl>
                      <li class="list" *ngFor="let item of filteredItems">
                        <a class="dropdown-item d-flex align-items-center px-2 py-1"
                           href="javascript:void(0)"
                           (click)="handleItemClick($event)">
                          <input type="checkbox"
                                 class="form-check-input me-2"
                                 [id]="'item-' + item.site_id"
                                 [(ngModel)]="item.selected"
                                 (ngModelChange)="onItemSelectionChange(item)"
                                 (click)="$event.stopPropagation()" />
                          <label [for]="'item-' + item.site_id"
                                 class="form-check-label flex-grow-1">
                            {{ item.site_name }}
                          </label>
                        </a>
                      </li>

                      <li *ngIf="shouldShowNoSitesFound()"
                          class="px-3 py-2 text-muted text-center">No sites found.</li>
                      <li *ngIf="shouldShowNoSitesAvailable()"
                          class="px-3 py-2 text-muted text-center">No sites available.</li>
                    </ng-template>

                  </ul>
                </div>
              </div>

              <!-- ── TYPE DROPDOWN (always visible) ── -->
              <div *ngIf="typeOptions.length>0" class="col-12 col-sm-6 col-md-4 col-lg-3">
                <div class="w-100" ngbDropdown [autoClose]="true" style="height:40px">
                  <button
                    class="btn text-dark dropdown-toggle d-flex justify-content-between align-items-center w-100"
                    type="button" ngbDropdownToggle>
                    <span>{{ selectedType.label || 'Select Type' }}</span>
                  </button>
                  <ul class="dropdown-menu" ngbDropdownMenu style="min-width:200px;">
                    <li *ngFor="let t of typeOptions">
                      <a class="dropdown-item d-flex justify-content-between align-items-center"
                         href="javascript:void(0)"
                         [class.active]="selectedType.value === t?.value"
                         (click)="onTypeChange(t)">
                        <span>{{ t?.label }}</span>
                        <span *ngIf="selectedType.value === t?.value"
                              class="ms-2 text-primary">&#10003;</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- ── TOWER MULTI-SELECT (single-site mode only) ── -->
              <div class="col-12 col-sm-6 col-md-4 col-lg-3"
                   *ngIf="showTowerDropdown">
                <div class="w-100" ngbDropdown [autoClose]="'outside'" style="height:40px">
                  <button
                    class="btn text-dark dropdown-toggle d-flex justify-content-between align-items-center w-100"
                    type="button" ngbDropdownToggle
                    [disabled]="towerLoading">
                    <span *ngIf="!towerLoading">{{ getSelectedTowerNames() }}</span>
                    <span *ngIf="towerLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    <span *ngIf="selectedTowersCount > 0 && !towerLoading"
                          class="badge bg-primary counter ms-2">{{ selectedTowersCount }}</span>
                  </button>

                  <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width:250px; max-height:300px; overflow-y:auto;">

                    <!-- tower search -->
                    <li class="px-1 py-1 sticky-top bg-white search-container">
                      <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                           style="position:absolute;right:7px;top:7px;">
                      <input type="text"
                             class="form-control form-control-sm searchbar"
                             placeholder="Search Towers..."
                             [(ngModel)]="towerSearchTerm"
                             (click)="handleItemClick($event)"
                             aria-label="Search towers">
                    </li>
                    <li><hr class="dropdown-divider mt-1 mb-0"></li>

                    <!-- tower shimmer -->
                    <ng-container *ngIf="towerLoading; else towerItemsTpl">
                      <li class="list" *ngFor="let _ of shimmerArray">
                        <div class="dropdown-item d-flex align-items-center px-2 py-1 shimmer-item">
                          <div class="shimmer-text me-2" style="width:16px;height:16px;border-radius:3px;"></div>
                          <div class="shimmer-text flex-grow-1" style="height:14px;"></div>
                        </div>
                      </li>
                    </ng-container>

                    <!-- tower real items -->
                    <ng-template #towerItemsTpl>
                      <li class="list" *ngFor="let tower of filteredTowers">
                        <a class="dropdown-item d-flex align-items-center px-2 py-1"
                           href="javascript:void(0)"
                           (click)="handleItemClick($event)">
                          <input type="checkbox"
                                 class="form-check-input me-2"
                                 [id]="'tower-' + tower.id"
                                 [(ngModel)]="tower.selected"
                                 (ngModelChange)="onTowerSelectionChange(tower)"
                                 (click)="$event.stopPropagation()" />
                          <label [for]="'tower-' + tower.id"
                                 class="form-check-label flex-grow-1">
                            {{ tower.tower_name }}
                          </label>  
                        </a>
                      </li>

                      <li *ngIf="filteredTowers.length === 0 && towerSearchTerm"
                          class="px-3 py-2 text-muted text-center">No towers found.</li>
                      <li *ngIf="towerItems.length === 0 && !towerLoading"
                          class="px-3 py-2 text-muted text-center">No towers available.</li>
                    </ng-template>

                  </ul>
                </div>
              </div>

            </div>
          </div>

          <!-- ================= RIGHT ACTION BUTTONS ================= -->
          <div class="col-12 col-xl-3">
            <div class="d-flex gap-2 justify-content-xl-end justify-content-start flex-wrap">
              <button class="btn btn-link text-danger fw-semibold"
                      (click)="onReset()">
                Reset
              </button>
              <button class="btn btn-primary px-4"
                      (click)="onApply()">
                Apply
              </button>
            </div>
          </div>

        </div>
        <!-- END GRID -->

      </div>
    </div>
  </div>
</div>